/* One placement calculation shared by the flat preview and print export. */
(() => {
  'use strict';
  window.ffImageLayout = ({height, imageWidth, imageHeight, mode = 'manual', corner = '', cornerFill = false, size = 38, x = 50, y = 50, cross}) => {
    const ratio = imageWidth / imageHeight;
    if (mode === 'fit') return {x: 0, y: 0, width: 1000, height};
    if (mode === 'fill') {
      const width = Math.max(1000, height * ratio), h = width / ratio;
      return {x: (1000 - width) / 2, y: (height - h) / 2, width, height: h};
    }
    if (corner && cross) {
      const right = corner.endsWith('right'), bottom = corner.startsWith('bottom');
      const left = right ? cross.right : 0, top = bottom ? cross.bottom : 0;
      const w = (right ? 1000 : cross.left) - left;
      const h = (bottom ? height : cross.top) - top;
      if (cornerFill) return {x: left, y: top, width: w, height: h};
      const pad = Math.min(30, w * .09, h * .12);
      const width = Math.min(w - 2 * pad, (h - 2 * pad) * ratio, Number(size) * 10);
      const drawH = width / ratio;
      return {x: left + (w - width) / 2, y: top + (h - drawH) / 2, width, height: drawH};
    }
    const width = Math.min(Number(size) * 10, height * .9 * ratio), h = width / ratio;
    return {x: (1000 - width) * Number(x) / 100, y: (height - h) * Number(y) / 100, width, height: h};
  };
})();
